import React from "react";
import Image from "next/image";
import { m } from "framer-motion";
import { fadeInUp } from "@/utils/motion/fade-in-up";
export default function PostBanner({ blog }) {
  return (
    <m.div
      initial={"from"}
      whileInView={"to"}
      variants={fadeInUp(0.75)}
      viewport={{ once: true }}
      className={`flex items-start justify-start relative w-full lg:h-[406px] h-[406px] overflow-hidden`}
    >
      <Image
        src={
          blog?.coverImage?.data?.attributes?.url ?? "/images/placeholder.svg"
        }
        quality={100}
        alt={blog?.coverImage?.data?.attributes?.name ?? "blog image"}
        sizes="(max-width: 479px) 100vw, 100vw"
        fill
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[rgb(0,0,0,0.4)] z-[1] flex md:flex-row flex-col md:justify-between justify-end w-full h-full items-end md:p-8 p-4">
        <div className="flex flex-col gap-1">
          {blog?.featured && (
            <div className="text-white text-[12px]">FEATURED</div>
          )}
          <h1 className="text-white text-[20px]">{blog?.title}</h1>
          <div className="text-white text-sm">
            {blog?.blog_categories?.data[0]?.attributes?.name} | By Admin
          </div>
        </div>
        {/* <div className="capitalize text-sm text-white underline">read more</div> */}
      </div>
    </m.div>
  );
}
